import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import ProgressiveImage from "@componentsShared/ProgressiveImage";
import useActionCookie from "@hooks/useActionCookie";
import useIsWebView from "@hooks/useIsWebview";
import React, { useState } from "react";
var COOKIE_NAME = "hideBanner";
var DownloadAppBanner = function DownloadAppBanner(_ref) {
  var _ref$hideDownloadBann = _ref.hideDownloadBanner,
    hideDownloadBanner = _ref$hideDownloadBann === void 0 ? false : _ref$hideDownloadBann;
  var _useTranslation = useTranslation(["web_common"]),
    t = _useTranslation.t;
  var isWebView = useIsWebView();
  var _useActionCookie = useActionCookie({
      cookieName: COOKIE_NAME,
      maxUsages: 2,
      numDays: 10
    }),
    _useActionCookie2 = _slicedToArray(_useActionCookie, 2),
    maxUsageNotReceived = _useActionCookie2[0],
    increaseUsage = _useActionCookie2[1];
  var _useState = useState(false),
    isClosed = _useState[0],
    setIsClosed = _useState[1];
  var canShowBanner = !isWebView && maxUsageNotReceived && !isClosed;
  if (!canShowBanner) return null;
  if (hideDownloadBanner) return;
  return /*#__PURE__*/React.createElement("div", {
    className: "m-show rounded-lg bg-[#00217C] px-3 py-2 fixed bottom-[88px] z-[99999] w-[calc(100%-32px)] left-4 flex justify-between items-center min-h-[48px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center gap-[12px]"
  }, /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    fetchpriority: "low",
    className: ["hasEvents"].join(" "),
    onClick: function onClick() {
      increaseUsage();
      setIsClosed(true);
    },
    src: CDN_LINK + "/assets/images/closewhite.svg",
    alt: "close",
    width: 10,
    height: 10,
    id: "close-banner"
  }), /*#__PURE__*/React.createElement("strong", {
    className: "text-white text-xs font-bold leading-6"
  }, t("use_syarah_app_best_experience", {
    ns: "web_common"
  }))), /*#__PURE__*/React.createElement("a", {
    className: "min-w-[115px] px-3 rounded-md bg-white shadow-[0px_0px_12px_0px_rgba(0,0,0,0.10)] text-[#231BFF] text-xs font-bold leading-6 flex justify-between items-center h-8",
    href: "https://qccx.adj.st/?adj_t=hulhg1o"
  }, t("continue_app", {
    ns: "web_common"
  })));
};
export default DownloadAppBanner;